export default "../../src/img/patterns/c3-150x150.jpeg";